import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as appActions from 'Actions/app';
import { isRepertoireCreateAvailable } from './createAvailability';
import { isRepertoireLibraryAvailable } from './libraryAvailability';
import { MobileMenuButton } from 'Components/RoadmapComponents/Menu';

interface PageNavProps {
  selected: string;
  onMenuOpen?: () => void;
}

const PageNav = ({ selected, onMenuOpen }: PageNavProps) => {
  const _navigate = useNavigate();
  const dispatch = useDispatch();
  const showCreateTab = isRepertoireCreateAvailable();
  const showLibraryTab = isRepertoireLibraryAvailable();

  return (
    <Box
      sx={{
        zIndex: 15,
        backgroundColor: '#040B13',
        height: 'var(--rep-nav-height, 100px)',
        display: 'flex',
        alignItems: 'flex-end',
      }}
    >
      <Box
        sx={{
          marginLeft: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          paddingBottom: '8px',
        }}
      >
        {onMenuOpen && <MobileMenuButton inline onClick={onMenuOpen} />}
        <Box
          sx={selected == 'Home' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
          // onClick={() => navigate("/home")}
          onClick={() => dispatch(appActions.setRepPageSelected('Home'))}
        >
          <Box sx={textStyles}>Home</Box>
        </Box>
        <Box
          sx={selected == 'Browse' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
          // onClick={() => navigate("/browse")}
          onClick={() => dispatch(appActions.setRepPageSelected('Browse'))}
        >
          <Box sx={textStyles}>Browse</Box>
        </Box>
        {showCreateTab && (
          <Box
            sx={selected == 'Create' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
            onClick={() => dispatch(appActions.setRepPageSelected('Create'))}
          >
            <Box sx={textStyles}>Create</Box>
          </Box>
        )}
        {showLibraryTab && (
          <Box
            sx={selected == 'Library' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
            onClick={() => dispatch(appActions.setRepPageSelected('Library'))}
          >
            <Box sx={textStyles}>Library</Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default PageNav;

const selectStyles = {
  color: 'white',
  margin: '0 5px',
  padding: '0px 32px',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    background: 'rgb(202,124,98,.25)',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: '0.3s',
    boxShadow: '0px 0px 5px 5px rgb(202,124,98,.25)',
  },
};

const selectSelectedStyles = {
  borderBottom: '2px solid',
  borderColor: '#6F87F1',
  color: '#6F87F1',
};

const textStyles = {
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '15px',
  lineHeight: '24px',
  letterSpacing: '1px',
};
